// work data

export const Achievements = [
    {
        id:1,
        name:"WeTech Goldman Sachs Scholar",
        description:"I was selected among 50 scholars from all over India for one-on-one mentorship",
        tags:["Corporate Job","Goldman Sachs","Mentorship"],  
        demo:"https://drive.google.com/file/d/13P9SHCgKTLvJNQrumbYCKseLtaRTWDM3/view?usp=sharing",
    },
    {
        id:2,
        name:"Microsoft Technical Associate",
        description:"Got awarded Microsoft Technical Associate Certificate in Introduction to Programming using Python ",
        tags:["Microsoft","MTA","Python"],        
        demo:"https://drive.google.com/file/d/11y6olV0D1hAb6omYmLrPWnQ0TIK3Xoic/view?usp=sharing",
        
    },
    {
        id:3,
        name:"3rd Position all over and 1st from India in ICONICS UG Conference",
        description:"Project on design of 2.4GHz Tatto Antenna  ",
        tags:["Electronics","International Conference","Winner"],        
        demo:"https://drive.google.com/file/d/1ipAImpAU35FdZ0JvAYpcag8D5aOCDG6M/view?usp=sharing",
        
    },
    {
        id:4,
        name:"Dean's List Awardee",
        description:"Been a part of Dean's List Felicitation awarded to top 10% students of the branch",
        tags:["Winner","Top Scorer"],
        demo:"",
    },
    {
        id:5,
        name:"Best Voice Project Award",
        description:"•	Best Voice Project Award in Rally to US + VetsinTech Online Hackathon on Devpost.",
        tags:["python","voice assistant","selenium","hackathon"],      
        demo:"https://devpost.com/goelesha2001?ref_content=user-portfolio&ref_feature=portfolio&ref_medium=global-nav",
    },
    {
        id:6,
        name:"Finalist in IEEE SheHacks amingst 100 teams",
        description:"Cleared all 3 rounds of IEEE SHE Hacks hackathon in which over 100 teams participated and ranked among top 5 teams.",
        tags:["python","selenium","web-automation"],
        demo:"https://drive.google.com/file/d/1JJ4xYrbhlnKg6bY2fzLTJMrreO-QvIaQ/view?usp=sharing",
       
    },
    /*{
        id:7,
        name:"Outstanding Performer in Verzo Internship",
        description:"Outstanding Performer in the internship on Machine Learning with Python ",
        tags:["Python","Machine Learning","Data Analysis"],       
        demo:"https://drive.google.com/file/d/1lQKuQ5GgI0en9N4GMO7gkCqgArPedyOv/view?usp=sharing",
        
    },*/
    /*{
        id:7,
        name:"Google Certified UX Designer",
        description:"Completed UI/UX Design Courses and got professional certificate from Google ",
        tags:["UI","UX","Design"],    
        demo:"https://www.credly.com/earner/earned/badge/281b177a-ee0f-4bac-9c4b-2d9f53619537",
        
    },*/
    
  
] 